import { ColDef, RowClickedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { aggridHeaderClass } from "src/components/common/common";
import Grid_Touch from "src/components/common/gridWrapper/Grid_Touch";
import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import { useGridSettingContent } from "src/utils/grid/GridSettingContent";
import { defaultColDef, getDefaultRowIndexColumnConfig } from "src/utils/grid/gridStyleUtils";
import { defaultMST3050_R01HeaderDto, MST3050_R01Dto, MST3050_R01HeaderDto } from "./Dto_MST3050_R01";
import { useMST3050_R01Store } from "./Store_MST3050_R01";
import { GridCustomColumnDefs } from "src/utils/grid/GridCustomColumnDefs";
import { onlyTouchGridStyle } from "src/utils/grid/gridFunctionUtil";

const COLUMN_STATE_KEY = 'MST3050_R01-grid-column-state';

interface Props {
	// data: CustomerResponseDto[]
	gridRef: React.RefObject<AgGridReact<MST3050_R01HeaderDto> | null>;
}

export const Table_MST3050_R01 = (props: Props) => {

	const { gridRef } = props;

	const { 
		MST3050_R01List, setMST3050_R01List,
		selectedMST3050_R01, setSelectedMST3050_R01, initSelectedMST3050_R01,
		editMST3050_R01, setEditMST3050_R01,
		columnState, setColumnState,
		scrollTop, setScrollTop,
		setDetailScrollTop,
	} = useMST3050_R01Store();
	const { brandCdList, itemGroupList, itemAccountList } = useCommonCodeStore();

	//const gridRef = useRef<AgGridReact>(null);
	const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(null);

    const { 
		getRowId,
		settingRowIndex, 
		settingSecondColumnCount,
		createRowClassRules,
		paddedGridData,
		renderIndexCell,
		defaultRowIndexCellButton,
		rowIndexCellButtonType1,
		rowIndexCellButtonType2,
		ensureSelectedRow,
	} = useGridSettingContent({
		gridRef,
		key: 'itemCd',
		gridData: MST3050_R01List,
		defaultGridData: defaultMST3050_R01HeaderDto,
		selectedRow: selectedMST3050_R01,
	});

	const headerNames: Record<string, string> = {
		rowIndex: "",
		itemCd: '품목코드',
		itemNm: '품명',
		itemSpec: '규격',
	}

	const getCellStyle = useCallback((params: any, key: string) => onlyTouchGridStyle(key, 'itemCd')(params), []);

	const baseColumnDefs: ColDef<MST3050_R01HeaderDto>[] = useMemo(() => [
		...getDefaultRowIndexColumnConfig(),
		{
			headerName: '품목코드', colId: 'itemCd', field: 'itemCd', width: 95, 
			cellStyle: (params) => getCellStyle(params, 'itemCd'),
			 
		},
		{
			headerName: '품명', colId: 'itemNm', field: 'itemNm', width: 210, 
			cellStyle: (params) => getCellStyle(params, 'itemNm'),
			
		},
		{
			headerName: '규격', colId: 'itemSpec', field: 'itemSpec', width: 180, 
			cellStyle: (params) => getCellStyle(params, 'itemSpec'),
			 
		},
	], [hoveredRowIndex, MST3050_R01List, selectedMST3050_R01]);



	const columnDefs: ColDef<MST3050_R01HeaderDto>[] = useMemo(() => {
		if (columnState === null) {
			return baseColumnDefs;
		}
		return GridCustomColumnDefs<MST3050_R01HeaderDto>({
			baseColumnDefs,
			columnState,
			headerNames,
			fallbackHeaderClass: aggridHeaderClass
		});
	}, [baseColumnDefs, columnState, headerNames]);

	
	

	const handleRowClick = useCallback((e: RowClickedEvent<MST3050_R01HeaderDto>) => {
		if (e.node.rowPinned === 'bottom') return;
		const rowData = e.data;
		if (!rowData) return;
		
		// 선택된 계좌와 같은지 확인
		const isSelected = selectedMST3050_R01?.itemCd === rowData.itemCd;
		if (isSelected) {
			setSelectedMST3050_R01(undefined);
		} else {
			setSelectedMST3050_R01(rowData);
		}
		setDetailScrollTop(null);
	}, [selectedMST3050_R01, setSelectedMST3050_R01, setDetailScrollTop]);

	const pinnedBottomRow = useMemo(() => ([{
		rowIndex: '',
		itemCd: MST3050_R01List.length.toLocaleString() + "건",
		editable: false,
	}]), [MST3050_R01List]);

	useEffect(() => { ensureSelectedRow(); }, [MST3050_R01List, selectedMST3050_R01]);

  return (
    <GridContextWrapper<MST3050_R01HeaderDto>
		gridRef={gridRef}
		paddedGridData={paddedGridData}
		initSelected={initSelectedMST3050_R01}
		defaultRowData={defaultMST3050_R01HeaderDto}
		baseColumnDefs={columnDefs}
		setColumnState={setColumnState}
		localStorageKey={COLUMN_STATE_KEY}
		menuItems={undefined}
	>
      <Grid_Touch
        ref={gridRef}
        rowData={paddedGridData}
        columnDefs={columnDefs}			defaultColDef={defaultColDef}
		getRowId={getRowId}
		
        rowClassRules={createRowClassRules<MST3050_R01HeaderDto>({
			idKey: 'itemCd',
			selectedList: selectedMST3050_R01 ? [selectedMST3050_R01.itemCd] : [],
			deletedList: []
		})}
        onRowClicked={handleRowClick}
		onCellKeyDown={undefined}
        pinnedBottomRowData={pinnedBottomRow}
                
		// Grid_Select에 공통 로직 처리를 위한 props 전달
		setHoveredRowIndex={setHoveredRowIndex}		//마우스 호버 상태 이벤트를 위한 저장
		columnStateKey={COLUMN_STATE_KEY}			//컬럼 상태 키(로컬스토리지)	
		setColumnState={setColumnState}				//컬럼 상태 저장
		scrollTop={scrollTop}
		setScrollTop={setScrollTop}
      />
    </GridContextWrapper>
  )
}